export const centerLocation = {
	lat: -1.2378167595291314,
	lng: 114.02678743956167,
};

const ultraVoucher = {
	event: 'payment_methods_select_ultravalue',
	code: 'ULTRA-VOUCHER',
	name: 'Ultra Value',
	minimum_amount: 1,
	maximum_amount: 10000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvdev.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2019-12-23T03%3A16%3A35.175Z1577070994-group.jpeg',
	image_size: '',
	image_size_payment: 'w-10 h-auto',
  mapping: {
    'pina': {
      source: 'pina',
      code: 'ULTRA-VOUCHER',
    }
  }
};

const qris = {
	event: 'payment_methods_select_qris',
	code: 'QRIS',
	name: 'QRIS',
	minimum_amount: 1,
	maximum_amount: 10000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/qris.jpg',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-10 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'QRIS',
    }
  }
};

const qrisMidtrans = {
	event: 'payment_methods_select_qris_midtrans',
	code: 'MIDTRANS_QRIS',
	name: 'QRIS',
	minimum_amount: 1,
	maximum_amount: 10000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/qris.jpg',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-10 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'MIDTRANS_QRIS',
    }
  }
};

const qrisBayarind = {
	event: 'payment_methods_select_qris_bayarind',
	code: 'BAYARIND_QRIS',
	name: 'QRIS BAYARIND',
	minimum_amount: 1,
	maximum_amount: 10000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/qris.jpg',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-10 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'BAYARIND_QRIS',
    }
  }
};

const qrisUv = {
	event: 'payment_methods_select_qris-gopay',
	code: 'QRIS-GOPAY',
	name: 'QRIS GOPAY',
	minimum_amount: 10000,
	maximum_amount: 2000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/qris.jpg',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-10 h-auto',
  mapping: {
    'pina': {
      source: 'pina',
      code: 'QRIS-GOPAY',
    }
  }
};

const vaBni = {
	event: 'payment_methods_select_va_bni',
	code: 'VABNI',
	name: 'Virtual Account BNI',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvproduction.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2022-09-02T02%3A40%3A55.520Z1662086455-BNI.png',
	image_size: 'w-9 h-auto',
	image_size_payment: 'w-14 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'BNI_VA',
    },
    'pina': {
      source: 'pina',
      code: 'VABNI',
    }
  }
};

export const vaBca = {
  event: 'payment_methods_select_va_bca',
	code: 'VADIRECTBCA',
	name: 'Virtual Account BCA',
	minimum_amount: 15000,
	maximum_amount: 9000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvdev.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2019-09-30T03%3A39%3A05.606Z1569814745-group.jpeg',
	image_size: 'w-9 h-auto',
	image_size_payment: 'w-16 h-auto',
  mapping: {
    'pina': {
      source: 'pina',
      code: 'VADIRECTBCA',
    },
    'pg': {
      source: 'pg',
      code: 'BCA_VA',
    },
    'direct': {
      source: 'direct',
      code: 'VADIRECTBCA',
    }
  }
};

const vaMandiri = {
	event: 'payment_methods_select_va_mandiri',
	code: 'VAMANDIRI',
	name: 'Virtual Account Mandiri',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvproduction.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2023-07-11T11%3A21%3A41.987Z1689074501-group.png',
	image_size: 'w-12 h-auto',
	image_size_payment: 'w-20 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'MANDIRI_VA',
    },
    'pina': {
      source: 'pina',
      code: 'VAMANDIRI',
    }
  }
};

const vaBri = {
	event: 'payment_methods_select_va_bri',
	code: 'VABRI',
	name: 'Virtual Account BRI',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvproduction.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2022-09-02T02%3A39%3A37.034Z1662086376-BRI.png',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-11 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'BRI_VA',
    },
    'pina': {
      source: 'pina',
      code: 'VABRI',
    }
  }
};

const vaPermata = {
	event: 'payment_methods_select_va_permata',
	code: 'VAPERMATA',
	name: 'Virtual Account PERMATA',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://uvproduction.oss-ap-southeast-5.aliyuncs.com/nero/assets/images/2022-09-02T02%3A36%3A49.642Z1662086209-Permata.png',
	image_size: 'w-20 h-auto',
	image_size_payment: 'w-28 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'PERMATA_VA',
    },
    'pina': {
      source: 'pina',
      code: 'VAPERMATA',
    }
  }
};

const vaBnc = {
	event: 'payment_methods_select_va_bnc',
	code: 'BNC_VA',
	name: 'Virtual Account BNC',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/nbc.png',
	image_size: 'w-10 h-auto',
	image_size_payment: 'w-28 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'BNC_VA',
    },
  }
};

const vaCimb = {
	event: 'payment_methods_select_va_cimb',
	code: 'CIMB_VA',
	name: 'Virtual Account CIMB',
	minimum_amount: 10000,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/default/cimb.png',
	image_size: 'w-11 h-auto',
	image_size_payment: 'w-28 h-auto',
  mapping: {
    'pg': {
      source: 'pg',
      code: 'CIMB_VA',
    },
  }
};

const loyaltyPoint = {
	event: 'payment_methods_select_loyalty_point',
	code: 'LOYALTY_POINT',
	name: 'Loyalty Point',
	minimum_amount: 0,
	maximum_amount: 100000000,
	status: 'ACTIVE',
	fee: 0,
	image_url: 'https://ufood.obs.ap-southeast-4.myhuaweicloud.com/development/banners/20260505134823_icon.webp',
	image_size: 'w-7 h-auto',
	image_size_payment: 'w-7 h-auto',
  mapping: {
    'direct': {
      source: 'direct',
      code: 'LOYALTY_POINT',
    },
  }
};

export const listPaymentMethod = [
	{
		id: 1,
		category: 'Payment Method',
		image_url: '',
		payment_method: [ultraVoucher],
	},
	{
		id: 2,
		category: 'Other Payment Method',
		image_url: '',
		payment_method: [qris, qrisMidtrans, qrisBayarind, qrisUv],
	},
	{
		id: 3,
		category: 'Virtual Account',
		image_url: '',
		payment_method: [vaMandiri, vaBca, vaBni, vaBri, vaPermata, vaBnc, vaCimb],
	},
];

export const OrderStatusList = {
	1: { message: 'Menunggu Konfirmasi dari Merchant', className: 'sr-process' },
	2: { message: 'Sedang Dikirim', className: 'sr-process' },
	3: { message: 'Sedang Diproses', className: 'sr-process' },
	4: { message: 'Selesai', className: 'sr-completed' },
	5: { message: 'Dibatalkan', className: 'sr-cancel' },
	0: { message: 'Menunggu Pembayaran', className: 'sr-waiting-payment' },
  13: { message: 'Siap diambil', className: 'sr-already-pickup' },
  14: { message: 'Makan di tempat', className: 'sr-dine-in' },
};

export const ListPaymentMethodAll = [
  ultraVoucher,
  vaBni,
  vaBca,
  vaMandiri,
  vaBri,
  vaPermata,
  vaBnc,
  vaCimb,
  qris,
  qrisMidtrans,
  qrisBayarind,
  qrisUv,
  loyaltyPoint,
];

export const uniqueID = process.env.REACT_APP_UNIQUE_ID;
export const apiUrl = process.env.REACT_APP_API_URL;
export const apiUrlB2B = process.env.REACT_APP_API_URL_B2B;
export const mainUrl = process.env.REACT_APP_SITE_MAIN_URL;
export const voucherUrl = process.env.REACT_APP_VOUCHER_URL;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const deliveryId = process.env.REACT_APP_DELIVERY_ID;
export const pickupId = process.env.REACT_APP_PICKUP_ID;
export const CountryName = 'Indonesia';
export const productNoImg = '/img/product-noimg.jpg';
export const companyName = 'UV';
export const currency = 'RP';
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const publicImageUrl = process.env.REACT_APP_PUBLIC_IMAGE_URL;
export const privateImageUrl = process.env.REACT_APP_PRIVATE_IMAGE_URL;
export const fcmToken = process.env.REACT_APP_FCMTOKEN;
export const googleAnalytics = process.env.REACT_APP_ANALYTIC;
export const metaPixelId = process.env.REACT_APP_META_PIXEL_ID;
export const loyaltyUrl = process.env.REACT_APP_LOYALTY;

export const HZNDeliveryStatus = "" | "NEW ORDER" | "ALLOCATING" | "REJECTED" | "DRIVER ASSIGNED" | "PICKING UP" | "DRIVER NOT FOUND" | "ITEM PICKED" | "ON DELIVERY" | "RECEIVED" | "COMPLETED" | "REACTIVATED" | "ON HOLD" | "CANCELLED" | "DELAYED" | "EXPIRED" | "RETURNED" | "FAILED";
export const listStatusLookingForDriver = ["ALLOCATING", "REJECTED", "CANCELLED", "DRIVER NOT FOUND"];
export const listStatusDriverExist = ["DRIVER ASSIGNED", "PICKING UP", "ITEM PICKED", "ON DELIVERY", "RECEIVED", "COMPLETED"];

export const maxLengthNotes = 255;

// timeout untuk api dan load image
export const timeout = 60 * 1000;
export const timeoutImage = 20 * 1000;

export const VOUCHER_STATUS = {
	PROCESSING: 0,
	COMPLETED: 1,
	CANCELED: 2,
};

export const VOUCHER_STATUS_NAME = {
	0: "processing",
	1: "completed",
	2: "canceled",
};


export const TopupStatusList = {
  0: { message: 'Menunggu Pembayaran', className: 'sr-waiting-payment' },
  1: { message: 'Selesai', className: 'sr-completed' },
	2: { message: 'Dibatalkan', className: 'sr-cancel' },
	3: { message: 'Sedang Diproses', className: 'sr-process' },
};

// setup color for commpany
export const roseViolet =  '#A84198';
export const roseVioletOpacity = 'rgba(168, 65, 152, 0.1)';
export const pinBall = '#D3D3D3';
export const darkGray = '#373737';
export const steam = '#DDDDDD';
export const tin = '#909090';
export const lightHouse = '#f4f4f4'
export const byzantium = '#732768';
export const star = '#FBAA19';
export const hardCoal = '#646464';
export const christmasSilver = '#E0E0E0';
export const blueChaos = '#4D9FFF';
export const lavenderPink = 'rgba(221,144,209,1)';
export const gradient = `linear-gradient(169deg, ${lavenderPink} 0%, ${byzantium} 100%)`;
export const bleachedSilk = '#f3f3f3';
export const laceVeil = '#ecebeb';
export const cerebralGrey = '#ccc';
export const white = '#fff';
export const squant = '#666';
export const purpleCactusFlower = '#7327681A'
export const pumpingSpice = '#F84B4B'
export const purplishPink = '#C761B7'
export const grey = '#808080'
export const midnightNavy = '#374151'

export const companyColors = {
  roseViolet: roseViolet,
  roseVioletOpacity: roseVioletOpacity,
  pinBall: pinBall,
  darkGray: darkGray,
  steam: steam,
  tin: tin,
  lightHouse: lightHouse,
  byzantium: byzantium,
  star: star,
  hardCoal: hardCoal,
  christmasSilver: christmasSilver,
  blueChaos: blueChaos,
  lavenderPink: lavenderPink,
  gradient: gradient,
  bleachedSilk: bleachedSilk,
  laceVeil: laceVeil,
  cerebralGrey: cerebralGrey,
  white: white,
  squant: squant,
  pumpingSpice: pumpingSpice,
  purplishPink: purplishPink,
  loyaltyFontColor: null,
  loyaltyBackgroundColor: null,
};

export const blacklistHistory = ['/payment', '/payment/success', '/payment-partner', '/ufood-x/payment', '/ufood-x/payment/success'];

export const WEB = "WEB"
export const MOBILE = "MOBILE"

// export const CS_UFOOD = "+6281111801081"
export const CS_UFOOD = "+628119276700"

export const GOOGLE_MAP_LIBRARIES = ['places', 'maps', 'marker'];

export const GEOLOCATION_PERMISSION = {
  GRANTED: 'granted',
  DENIED: 'denied',
  PROMPT: 'prompt',
  UNKNOWN: null,
};

export const GEOLOCATION_ASK_TIMEOUT = 2000;

export const PERMISSION_PERMISSION = [
  {
      "location_permission": GEOLOCATION_PERMISSION.PROMPT,
      "wsid": process.env.REACT_APP_BCA_WSID_MOBILE,
      "device": MOBILE
  },
  {
      "location_permission": GEOLOCATION_PERMISSION.PROMPT,
      "wsid": process.env.REACT_APP_BCA_WSID_WEB,
      "device": WEB
  }
];

export const GOOGLE_MAP_STATUS = {
  INVALID_REQUEST: 'INVALID_REQUEST',
  NOT_FOUND: 'NOT_FOUND',
  OK: 'OK',
  OVER_QUERY_LIMIT: 'OVER_QUERY_LIMIT',
  REQUEST_DENIED: 'REQUEST_DENIED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  ZERO_RESULTS: 'ZERO_RESULTS',
};

export const BCA_STATUS_CODE = {
  BLOCKED: '409PS01',
  SUCCESS: '200PS00'
}

export const MINIMUM_DISTANCE = 0.1;

export const UFOODX_BASE_URL = '/ufood-x';

export const dayMap = {
  0: { key: "sun", label: "Minggu" },
  1: { key: "mon", label: "Senin" },
  2: { key: "tue", label: "Selasa" },
  3: { key: "wed", label: "Rabu" },
  4: { key: "thu", label: "Kamis" },
  5: { key: "fri", label: "Jumat" },
  6: { key: "sat", label: "Sabtu" },
};

export const HeaderSlot = Object.freeze({
  BACK: 'BACK',
  NAME: 'NAME',
  TYPE: 'TYPE',
  SEARCH: 'SEARCH',
  TRANSACTION: 'TRANSACTION',
  CUSTOMERCARE: 'CUSTOMERCARE',
});

export const USER_STATUS = {
  ACTIVE: 'A',
  INACTIVE: 'I',
  PENDING: 'P',
};

export const minimumAmountBca = 10000;

const VA_BNI_CONFIG = {
  image_size: 'w-9 h-auto',
  image_size_payment: 'w-14 h-auto',
};

const VA_BCA_CONFIG = {
  image_size: 'w-9 h-auto',
	image_size_payment: 'w-16 h-auto',
};

const VA_MANDIRI_CONFIG = {
  image_size: 'w-12 h-auto',
  image_size_payment: 'w-20 h-auto',
};

const VA_PERMATA_CONFIG = {
  image_size: 'w-20 h-auto',
  image_size_payment: 'w-28 h-auto',
};

const VA_BRI_CONFIG = {
  image_size: 'w-7 h-auto',
	image_size_payment: 'w-11 h-auto',
};

export const PAYMENT_UI_CONFIG = {
  LOYALTY: {
    image_size: 'w-7 h-auto',
    image_size_payment: 'w-10 h-auto',
  },
  QRIS: {
    image_size: 'w-7 h-auto',
    image_size_payment: 'w-10 h-auto',
  },
  MIDTRANS_QRIS: {
    image_size: 'w-7 h-auto',
    image_size_payment: 'w-10 h-auto',
  },
  BAYARIND_QRIS: {
    image_size: 'w-7 h-auto',
    image_size_payment: 'w-10 h-auto',
  },
  "QRIS-GOPAY": {
    image_size: 'w-7 h-auto',
    image_size_payment: 'w-10 h-auto',
  },
  BNI_VA: VA_BNI_CONFIG,
  VABNI: VA_BNI_CONFIG,
  CIMB_VA: {
    image_size: 'w-11 h-auto',
    image_size_payment: 'w-28 h-auto',
  },
  BRI_VA: VA_BRI_CONFIG,
  VABRI: VA_BRI_CONFIG,
  MANDIRI_VA: VA_MANDIRI_CONFIG,
  VAMANDIRI: VA_MANDIRI_CONFIG,
  PERMATA_VA: {
    image_size: 'w-20 h-auto',
    image_size_payment: 'w-28 h-auto',
  },
  BNC_VA: {
    image_size: 'w-10 h-auto',
    image_size_payment: 'w-28 h-auto',
  },
  VADIRECTBCA: VA_BCA_CONFIG,
  BCA_VA: VA_BCA_CONFIG
};

export const deeplinkMobile = [
	{
		name: 'BCA Mobile',
		short: 'BCA',
		androidScheme: 'intent://#Intent;package=com.bca.mybca.omni.android;end',
		playstore: 'https://play.google.com/store/apps/details?id=com.bca.mybca.omni.android',
    iosScheme: null,
    appStore: 'https://apps.apple.com/id/app/mybca-new-bca-banking-apps/id1440241902',
		bgColor: 'bg-blue-400/10',
		textColor: 'text-blue-500',
		desc: 'Bayar langsung pakai rekening BCA',
	},
	{
		name: 'BRImo',
		short: 'BRI',
		androidScheme: 'https://play.google.com/store/apps/details?id=id.co.qualitas.qitapp&hl=id',
		playstore: 'https://play.google.com/store/apps/details?id=id.co.bri.brimons',
    iosScheme: 'https://apps.apple.com/id/app/qita-by-bri/id6747552980',
    appStore: 'https://apps.apple.com/id/app/brimo-bri/id1439730817',
		bgColor: 'bg-blue-400/10',
		textColor: 'text-blue-500',
		desc: 'Pembayaran cepat via BRImo',
	},
	{
		name: 'Ultra Voucher',
		short: 'UV',
		androidScheme: 'http://onelink.to/ultravoucher',
		playstore: 'https://play.google.com/store/apps/details?id=com.ultravoucher.uv',
    iosScheme: null,
    appStore: 'http://onelink.to/ultravoucher',
		bgColor: 'bg-blue-400/10',
		textColor: 'text-blue-500',
		desc: 'Voucher & loyalty payment',
	},
	{
		name: 'One Smile',
		short: 'OS',
		androidScheme: 'https://onesmile.onelink.me/43oa/DownloadOS',
		playstore: 'https://play.google.com/store/apps/details?id=com.sinarmasland.onesmile',
    iosScheme: 'https://onesmile.onelink.me/43oa/DownloadOS',
    appStore: 'https://apps.apple.com/id/app/onesmile/id1551898065',
		bgColor: 'bg-green-400/10',
		textColor: 'text-green-500',
		desc: 'Member benefit & rewards',
	},
];

export const VOUCHER_GLOBAL_PURPOSE = {
  PRODUCT: "PRODUCT",
  DELIVERY: "DELIVERY"
}

export const AGE_VERIFICATION_STATUS = {
	GRANTED: 'granted',
	DENIED: 'denied',
	PROMPT: 'prompt',
  UNKNOWN: null,
};

export const ALL_CATEGORY = {
  categoryName: 'All',
  categoryImage: '',
  catSlug: 'all',
};